import React, { Component, useEffect, useState } from 'react';
import { Helper } from '../../../src/ToolKit/toolkit.js';
import { DataClass, enums } from '../../../src/ToolKit/DataClass.js'

import $ from 'jquery/dist/jquery';
import { Menu, ColumnType, Action, AlertD, YesNo, DropDownBox, SelectBasic, DayTimeSelector, FormDiv, InputBox, Icon, SideView, SideItem, FilterView, SpecValues, ProTable, SimpleButton, CustomHelper, FixedMessage, Captia, Column, NewRecordValue, FromBasic, AddButton, FileProgess, LoadingBar, FromSubmit, InputTextBox, InputPasswordBox, Model, Confirm, RowState, ModalCustom, QuickUploader } from '../.././Componet';
import {   useParams } from "react-router-dom";
import {   Route } from "react-router-dom";
import { Modal } from 'bootstrap';
import { data } from 'jquery';
 

 
export class ProductMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });
        this.Delete = this.Delete.bind(this);
        this.Refersh = this.Refersh.bind(this);
        this.ListAll = this.ListAll.bind(this);
        this.CreateGameProduct = this.CreateGameProduct.bind(this);
        this.UpdatePriceForGamePrice = this.UpdatePriceForGamePrice.bind(this);
        this.SetViewStatusForGamesAuto = this.SetViewStatusForGamesAuto.bind(this);
    }

    Delete(record) {
        let hlp = new Helper();
        let cmd = this;
        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('Product', 'Delete', { Model: record }, function (data) {
                cmd.componentDidMount();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }

    Refersh() {


        let cmd = this;
        let h = new Helper();
        h.Ajax('Product', this.props.selectMode == undefined ? 'List' : 'OnlySelectable', h.GetPostData(), function (data) {
            cmd.setState({ isLoaded: true, Records: data });
        });
    }
    ListAll() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('Product', 'ListAll', {}, function (data) {
            cmd.setState({ isLoaded: true, Records: data });
        });
    }
    RefershPrice() {
        let cmd = this;
        let h = new Helper();
        let val = $('txtprice').val();
        h.Ajax('Product', 'UpdatePrice', { value: val }, function (data) {
            h.Alert(data.message);
            cmd.Refersh();
        });
    }
    CreateGameProduct() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('Product', 'CreateProductByAvaGames', {}, function (data) {
            cmd.Refersh();
            h.Alert(data.message);
        });
    }
    SetViewStatusForGamesAuto() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('Product', 'SetViewStatusForGamesAuto', {}, function (data) {
            cmd.Refersh();
            h.Alert(data.message);
        });
    }
    UpdatePriceForGamePrice() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('Product', 'UpdatePriceForGamePrice', {}, function (data) {
            cmd.Refersh();
            h.Alert(data.message);
        });
    }




    Select(v) {
        window.selectFun(v);
    }


    componentDidMount() {
        this.Refersh();
        if(this.props.selectMode != undefined)
        {
            
        }
    }

    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle=''>
                <InputTextBox caption="نام" columnName="keyword" model="keyword" size="50%" />
                <DropDownBox caption="نام دسته" columnName="categroy" entity="ProdcutCategory" size="50%" includeAll={true} model="categroy" />

                <center>
                    <SimpleButton title="جستجو" onClick={this.Refersh}></SimpleButton>
                    <AddButton title='' entity='Product' />

                    {this.props.selectMode == undefined &&
                        <SimpleButton title="همه محصولات و زیرمجموعه هایش" onClick={this.ListAll}></SimpleButton>
                    }
                    {this.props.selectMode == undefined &&
                        <SimpleButton title="بروز رسانی قیمت ها از ارز" ForApp="MultiPrice" onClick={this.RefershPrice}></SimpleButton>
                    }
                    {this.props.selectMode == undefined &&
                        <InputTextBox size="25%" ForApp="MultiPrice" customHelper={CustomHelper.isDigitngGroupedNumber} caption="نرخ دلخواه" model="price" columnName="price" />
                    }
                    <br />
                    <SimpleButton title="ایجاد محصولات بازی های دارای اکانت" ForApp="Game" onClick={this.CreateGameProduct}></SimpleButton>
                    <SimpleButton title="بروزسانی قیمت از ظرفیت بازی ها" ForApp="Game" onClick={this.UpdatePriceForGamePrice}></SimpleButton>
                    <SimpleButton title="بروزسانی وضعیت قابل سفارش بازی ها" ForApp="Game" onClick={this.SetViewStatusForGamesAuto}></SimpleButton>

                </center>
              
               <ProTable Records={this.state.Records} datasourcename='Products'>
                    <Column metaForDisplay={DataClass.Product.Id} />
                    <Column metaForDisplay={DataClass.Product.Name} />
                    <Column metaForDisplay={DataClass.Product.Description} />
                    <Column metaForDisplay={DataClass.Product.CategoryName} />



                    {this.props.selectMode == undefined &&
                    <Action caption="ویرایش" type="Link" columnName='id' pageName="/Product/Edit" />
                    }
                    {this.props.selectMode == undefined &&
                        <Action caption="گالری محصول" type="Link" columnName='id' pageName="/Product/Images" />
                    }
                    {this.props.selectMode == undefined &&
                        <Action caption="محصولات های زیرمجموعه" type="Link" columnName='id' pageName="/Product/Sub" />
                    }
                    {this.props.selectMode == undefined &&
                    <Action caption="تعیین وضعیت و نرخ محصولات زیرمجموعه" type="Link" columnName='id' pageName="/Product/SubPrice" />
                    }

                    {this.props.selectMode == undefined &&
                        <Action caption="حذف" type="function" targetFun={this.Delete} />
                    }
                    {this.props.selectMode != undefined &&
                        <Action caption="انتخاب" type="function" targetFun={this.Select} />
                    }


                </ProTable>
            </FromBasic>
        }
    }



}

export function EditProduct() {
    const queryS = useParams();
    return <AddProduct id={queryS.id} />
}

/* درج و و یرایش رکورد */

export function EditOrder() {
    const queryS = useParams();
    return <AddOrder id={queryS.id} />
}
export function InputSerail() {
    const queryS = useParams();
    return <SetSerail id={queryS.id} />
}
export class AddProduct extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.submit = this.submit.bind(this);
    }
    submit() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let id = (cmd.id == undefined ? -1 : cmd.id);
        let o = h.GetPostData();
        h.Ajax('Product', (cmd.id == '-1' ? 'Insert' : 'Update'), { Model: o, id: id }, function (data) {
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                h.GoBack();
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
    }
    componentDidMount() {
        let h = new Helper();
        if (this.id != -1) {
            h.Ajax('Product', 'Get', { id: this.id }, function (data) {
                h.SetDataBack(data);
            });


        }
    }
    render() {
        return <FromSubmit submitBev={this.submit}>
             
            <InputBox meta={DataClass.Product.Name} size='33%' />
            <InputBox meta={DataClass.Product.OldName} size='33%' />
            <InputBox meta={DataClass.Product.ProductType} size='33%' />
            <InputBox meta={DataClass.Product.ProdcutCategoryId} size='33%' />
            <InputBox ForApp="MultiPrice" meta={DataClass.Product.PriceInUnit} size='33%' />
            <InputBox meta={DataClass.Product.PriceInRail} size='33%' />
            <InputBox ForApp="Granty" meta={DataClass.Product.Granty} size='33%' />
            <InputBox meta={DataClass.Product.ViewStatus} size='33%' />
            <InputTextBox mulitFile={false} initvalue="imageUrl" size="100%" customHelper={CustomHelper.Image} caption="تصویر" columnName="imageUrl" model="ImageUrl" />

            <InputBox meta={DataClass.Product.Description} size='100%' />
            <InputBox meta={DataClass.Product.Context} size='100%' />
            
            <InputBox ForApp="Game" meta={DataClass.Product.GameId} size='50%' />
            <InputBox ForApp="Game" meta={DataClass.Product.UsageType} size='50%' />
            <InputBox meta={DataClass.Product.DescrLong} size='100%' customHelper={CustomHelper.Html} />
        </FromSubmit>

    }

}


class ProductImagesMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.state = { isLoaded: false, Records: [] };
        this.submit = this.submit.bind(this);
        this.SlideShows = [];
    }
    componentDidMount() {
        let cmd = this;
        let hlp = new Helper();
        hlp.Ajax("Product", "ListImages", {id:this.id}, function (datas) {
            cmd.setState({ isLoaded: true, Records: datas });
            cmd.SlideShows = datas;
        }, function () { });

    }
    submit() {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let data = h.GetDataGrouped(window.SlideShows);
        h.Ajax('Product', 'SaveImages', { id: this.id, Inserted: data[RowState.Inserted], Updated: data[RowState.Changed], deleted: data[RowState.Deleted] }
            , function (data) {
                h.MessageBox(FixedMessage.NoProblem, FixedMessage.Result);
                h.GoBack();
            },
        )
    }
    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();
        }
        else {
            return <FromSubmit SubmitButtonOnTop={true} submitBev={this.submit} >
                <QuickUploader mulitFile={true} justImage={true} onUpload={(urls) => {
                    let data = [...this.SlideShows];
                    for (let i = 0; i < urls.length; i++) {
                        data.push({ imageUrl: urls[i], rowState: RowState.Inserted });
                    }
                    this.setState({ isLoaded: true, Records: data });
                    window.SlideShows = data;
                }} ></QuickUploader>
                <ProTable datasourcename='SlideShows' Records={this.state.Records} Insertable={true} Deleteable={true}>

                       <Column columnName='imageUrl' caption='تصویر' type={ColumnType.InputImage} />
                   <asdas></asdas>

                </ProTable>

            </FromSubmit>

        }

    }


}




export class CustomerMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });
        this.Delete = this.Delete.bind(this);
        this.Refersh = this.Refersh.bind(this);

    }

    Delete(record) {
        let hlp = new Helper();
        let cmd = this;
        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('Customer', 'Delete', { Model: record }, function (data) {
                cmd.componentDidMount();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }
    showId(record) {
        let h = new Helper();
        h.MessageBox('<a href="/IdPaper/' + record.mobile + '.jpg" target="_blank" ><img style="width:100%" src="/IdPaper/' + record.mobile + '.jpg?iq=' + Math.random().toString() + '" /></a>', 'کارت ملی')
    }
    Refersh() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('Customer', 'List', {}, function (data) {
            cmd.setState({ isLoaded: true, Records: data });
        });
    }

    componentDidMount() {
        this.Refersh();
    }

    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle=''>
                <AddButton title='' entity='Customer' /> <ProTable Records={this.state.Records} datasourcename='Customers'>
                    <Column metaForDisplay={DataClass.Customer.Id} />
                    <Column metaForDisplay={DataClass.Customer.Name} />
                    <Column metaForDisplay={DataClass.Customer.Mobile} />
                    <Column metaForDisplay={DataClass.Customer.Address} />

                    <Action caption="ویرایش" type="Link" pageName="/Customer/Edit" columnName="id" />
                    <Action caption="نمایش کارت ملی ارسالی" type="function" targetFun={this.showId} />
                    <Action caption="ضمیمه" Icon="Cat" type="Link" pageName="/Attachs/Customer" columnName="id" />

                    <Action caption="حذف" type="function" targetFun={this.Delete} />




                </ProTable>
            </FromBasic>
        }
    }



}


 
 
/* ویرایش */
export function EditCustomer() {
    const queryS = useParams();
    return <AddCustomer id={queryS.id} />
}

/* درج و و یرایش رکورد */


export class AddCustomer extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.submit = this.submit.bind(this);
    }
    submit() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let id = (cmd.id == undefined ? -1 : cmd.id);
        let o = h.GetPostData();
        h.Ajax('Customer', (cmd.id == '-1' ? 'Insert' : 'Update'), { Model: o, id: id }, function (data) {
            if (data.status == 200) {
                if (window.windowCallBack != undefined) {
                 
                    window.windowCallBack(data.refId);
                    window.close();
                  
                }
                else {
                    h.MessageBox(data.message, FixedMessage.Result);
                    h.GoBack();
                }
            
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
    }
    componentDidMount() {
        let h = new Helper();
        if (this.id != -1) {
            h.Ajax('Customer', 'Get', { id: this.id }, function (data) {
                h.SetDataBack(data);
            });


        }
    }
    render() {
        return <FromSubmit submitBev={this.submit}>
          
            <InputBox meta={DataClass.Customer.Name} size='25%' />
            <InputBox meta={DataClass.Customer.Mobile} size='25%' />
            <InputBox meta={DataClass.Customer.NatCode} size='25%' />
            <InputBox meta={DataClass.Customer.CustomeGroupId} size='25%' />
            <InputBox meta={DataClass.Customer.PostCode} size='50%' />
            <InputBox meta={DataClass.Customer.CityId} size='50%' />

            <InputBox meta={DataClass.Customer.Address} size='100%' />
           

        </FromSubmit>

    }

}

class AddOrder extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { isLoaded: true, Records: [] };
        this.submit = this.submit.bind(this);
        this.Copy = this.Copy.bind(this);
        this.onChange = this.onChange.bind(this);
        this.id = this.props.id;
        window.OrderItems = this.state.Records;
    }
    componentDidMount() {
      /* */
        if (this.id != -1) {
            let cmd = this;
            let hlp = new Helper();
            hlp.Ajax("Order", "Get", { id: this.id }, function (datas) {
                // cmd.setState({ isLoaded: true, Records: datas });
                hlp.SetDataBack(datas.order);
                window.OrderItems = datas.items;
                cmd.setState({ isLoaded: true, Records: window.OrderItems });
                cmd.setTotalFactor();
            }, function () { });
        }
        else {
            let hlp = new Helper();
            let cmd = this;
            hlp.Ajax("Order", "NewOrder", { }, function (datas) {
                // cmd.setState({ isLoaded: true, Records: datas });
                hlp.SetDataBack(datas);
                cmd.setTotalFactor();
            }, function () { });
        }
        
    }
    submit() {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        for (var i = 0; i < window.OrderItems.length; i++) {
            if (window.OrderItems[i].RowState != RowState.Deleted) {
                window.OrderItems[i].startGranteyDate = h.perToMil(window.OrderItems[i].startGranteyDate);
                window.OrderItems[i].endGranteyDate = h.perToMil(window.OrderItems[i].endGranteyDate);
            }
        }


        let data = h.GetDataGrouped(window.OrderItems);

        h.Ajax('Order', this.id == -1 ? 'Insert' : 'Update', { updateForce: $('#chkForceUpdate').val() == 'on', id: this.id, model: h.GetPostData(), Inserted: data[RowState.Inserted], Updated: data[RowState.Changed], deleted: data[RowState.Deleted] }
            , function (data) {
                h.MessageBox(data.message, FixedMessage.Result);
                if (data.status == 200) {
                    h.GoBack();
                }
             
            },
        )
    }
    Copy(record) {
        
        let cmd = this;
        let helper = new Helper();
        var o = {};
        let keys = Object.keys(record);
        for (let i = 0; i < keys.length; i++) {
            o[keys[i]] = record[keys[i]];
        }
        o.rowState = RowState.Inserted;
        window.OrderItems.push(o);
        cmd.setState({ isLoaded: true, Records: window.OrderItems });
        setTimeout(() => {
            var itm = $('[entity="OrderItemProduct"]');
            helper.Select2AjaxSelectOption(record.productId, itm[itm.length - 1], helper);

        }, 1000);
    }
    onChange(dataSource, newValue, index, ColName) {
        let cmd = this;
        const calcPrice = () => {
            let h = new Helper();
            dataSource[index]['totalPrice'] = dataSource[index]['unitPrice'] * dataSource[index]['count'];
            cmd.setTotalFactor();
        }
        if ((ColName == 'productId') || (ColName == 'needGranty') ) {
            let h = new Helper();
            h.Ajax('Product', 'Get', { id: dataSource[index]['productId'] },
                (data) => {
                    if (data == null) {
                        return;
                    }


                    if (data.productType != 0) {
                        dataSource[index]['needGranty'] = false;
                    }
                    if ((ColName == 'productId')) {
                        if (data.productType == 0) {
                            dataSource[index]['needGranty'] = true;
                        }
                    }

                    let needGranty = dataSource[index]['needGranty'];
                   
                    if (ColName == 'productId') {
                        dataSource[index]['unitPrice'] = data.priceInRail + (needGranty == true ? data.granty : 0);
                    }
                    else {
                        dataSource[index]['unitPrice'] = needGranty == true ? dataSource[index]['unitPrice'] + data.granty : dataSource[index]['unitPrice'] - data.granty;
                    }
                 
                    calcPrice();
                    window.OrderItems = dataSource;
                    cmd.setState({ isLoaded: true, Records: window.OrderItems });

                }


            );
        }
      
        if (ColName == 'unitPrice') {
            calcPrice();
        }
        if (ColName == 'count') {
            calcPrice();
        }
    }

    setTotalFactor = () => {
      
        let sum = 0;
        for (var index = 0; index < window.OrderItems.length; index += 1) {
            try {

                if (window.OrderItems[index].rowState != RowState.Deleted)
                {
                   
                    sum += window.OrderItems[index]['totalPrice'];

                }
                
            }
            catch (ex) {

            }
           
        }
        let h = new Helper();
        try {
            sum -= h.GetNumber($('#txttotalDiscount').val());
        }
        catch
        {

        }
        $('#txtTotalFactor').val(h.addCommas(sum));
        $('#txtTotalFactorFa').val(h.numberToPersianWords(sum))
    }

    newCustomer() {
        let h = window.open('/Admin/Customer/Add');
 
        h.windowCallBack = (refId) => {
            let helper = new Helper();

            helper.SetDataBack({ customerId: refId });
        };
    }

    

    render() {
        let newDate = new Date();
        newDate.setFullYear(newDate.getFullYear() + 1);
        if (this.state.isLoaded == false) {
            return LoadingBar();
        }
        else {
            return <FromSubmit SubmitButtonOnTop={true} submitBev={this.submit} >
                <ModalCustom title="جستجوی کالا" id="txtProduct">
                    <ProductMgt selectMode={true } />
                </ModalCustom>

                <InputBox meta={DataClass.Order.FactorNumber} size='33%' />
                <InputBox meta={DataClass.Order.CustomerId} size='33%' />
                <InputBox meta={DataClass.Order.OrderDate} size='33%' />
                <InputTextBox columnName="totalDiscount" initvalue="totalDiscount" model="totalDiscount" mustFill="yes" caption="تخفیف کلی" customHelper={CustomHelper.isDigitngGroupedNumber} onChange={() => { this.setTotalFactor() }} size='33%' />
                <InputBox meta={DataClass.Order.Descr} size='66%' />
                <center>
                    <SimpleButton title="مشتری جدید" onClick={this.newCustomer }></SimpleButton>
                    <SimpleButton title="محاسبه و اعمال تخفیف"
                        onClick={() => {
                            let h = new Helper();
                            let input = h.GetPostData();
                            h.Ajax('Order', 'CalcDiscount', input, (data) => {
                                $('#txttotalDiscount').val(data.refId);
                                this.setTotalFactor();
                            });

                        }}
                    ></SimpleButton>
                </center>
                <ProTable rowNumbering={true} afterChange={this.onChange} datasourcename='OrderItems' Records={this.state.Records} Insertable={true} Deleteable={true}>
                    <NewRecordValue columnName="startGranteyDate" newValue={new Helper().MilToPer(new Date())}></NewRecordValue>
                    <NewRecordValue columnName="endGranteyDate" newValue={
                        new Helper().MilToPer(newDate)
                    }></NewRecordValue>
                    <NewRecordValue columnName="needGranty" newValue={
                        window.config.Granty == "True"
                    }></NewRecordValue>
                    <NewRecordValue columnName="count" newValue={1}></NewRecordValue>
                    {window.config.GrantyPrice == "True" &&
                        <Column type={ColumnType.InputCheck} columnName="needGranty" caption="شامل گارانتی" titleColumnName='productName' />

                    }
                      <Column width="350px" metaForInput={DataClass.OrderItem.ProductId} titleColumnName='productName' />
                    <Column columnName="serach" initFunc={() => {

                        $('#txtcategroy').next('.select2-container').css('width', '500px');
                        $('#txtcategroy').next('.dropdown-wrapper').css('width', '500px');

                    }} caption="" type={ColumnType.Serach} targetColumn="productId" modalId="txtProduct" destValue="id" destTitle="name" colNameValue="productName" />
                    <Column width="250px" metaForInput={DataClass.OrderItem.UnitPrice}  />
                    <Column width="80px" metaForInput={DataClass.OrderItem.Count} />

                    <Column metaForDisplay={DataClass.OrderItem.TotalPrice} />
                    {this.id != -1 && window.config.GrantyPrice=="True" &&
                        <Column metaForInput={DataClass.OrderItem.StartGranteyDate} />
                    }
                    {this.id != -1 && window.config.GrantyPrice == "True" &&
                        <Column metaForInput={DataClass.OrderItem.EndGranteyDate} />
                    }
                    {this.id != -1 && window.config.GrantyPrice == "True" &&
                        <Column metaForInput={DataClass.OrderItem.Serial} />

                    }
                    <Action caption="کپی این ردیف" type="function" Icon="Copy" targetFun={this.Copy} />

                </ProTable>
                <InputTextBox columnName="TotalFactor" caption="جمع فاکتور" size='33%' model="TotalFactor" customHelper={CustomHelper.isDigitngGroupedNumber} disabled></InputTextBox>
                <InputTextBox columnName="TotalFactorFa" caption="به حروف" size='66%' model="TotalFactorFA" disabled></InputTextBox>
                <center>
                   
                    {this.id != -1 &&
                        <span>
                        <br/>
                            <input type="checkbox" id="chkForceUpdate" ></input>در صورت پرداخت اینترنتی بازهم ویرایش کن    
                        </span>
                    }
                </center>

            </FromSubmit>

        }

    }


}





class SetSerail extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { isLoaded: true, Records: [] };
        this.submit = this.submit.bind(this);
        this.id = this.props.id;
        window.OrderItems = this.state.Records;
    }
    componentDidMount() {
        /* */
       
            let cmd = this;
            let hlp = new Helper();
            hlp.Ajax("Order", "GetForInputSerail", { id: this.id }, function (datas) {
                // cmd.setState({ isLoaded: true, Records: datas });
                hlp.SetDataBack(datas.order);
                window.OrderItems = datas.items;
                cmd.setState({ isLoaded: true, Records: window.OrderItems });
            }, function () { });
       

    }
    submit() {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }

        

        let data = h.GetDataGrouped(window.OrderItems);
        for (let i = 0; i < data[RowState.Changed].length; i++) {
            data[RowState.Changed][i].startGranteyDate = h.perToMil(data[RowState.Changed][i].startGranteyDate);
            data[RowState.Changed][i].endGranteyDate = h.perToMil(data[RowState.Changed][i].endGranteyDate)
        }
        h.Ajax('Order',  'SetSerail', { id: this.id, Updated: data[RowState.Changed] }
            , function (data) {
                h.MessageBox(data.message, FixedMessage.Result);
                if (data.status == 200) {
                    h.GoBack();
                }

            },
        )
    }
   
     

     


    render() {
        let newDate = new Date();
        newDate.setFullYear(newDate.getFullYear() + 1);
        if (this.state.isLoaded == false) {
            return LoadingBar();
        }
        else {
            return <FromSubmit SubmitButtonOnTop={true} submitBev={this.submit} >
                
                <ProTable rowNumbering={true}  datasourcename='OrderItems' Records={this.state.Records}  >
                  
             

                    <Column caption="نام محصول" columnName="productName" type={ColumnType.DisplayValue} />
                

                    <Column metaForInput={DataClass.OrderItem.StartGranteyDate} />
                    <Column metaForInput={DataClass.OrderItem.EndGranteyDate} />
                    <Column mustFill={'Yes'} caption="سریال" columnName="serial" type={ColumnType.InputText} />
                  

                </ProTable>
               
            </FromSubmit>

        }

    }


}



function DeleryManagement() {
    const [pageState, orders] = useState({ orders: [], isLoaded: false, filter: '' });

    const serach = () => {
        let h = new Helper();
        h.SaveState();
        let data = h.GetPostData();
        h.Ajax('Order', 'UnDelery', {}, (data) => {
            orders({ orders: data, isLoaded: true, filter: '', pageTemplate: pageState.pageTemplate, templateId: pageState.templateId });

        });
    };
    const Print = (record) => {
        window.open('/sf/' + record.id);

    }


    const submit = () => {
        var h = new Helper();
        var ids = [];
        var recs = h.GetRecordWithCircita(pageState.orders, 'selected', true);
        for (let i = 0; i < recs.length; i++) {
            ids.push(recs[i].id);
        }
        h.Validate();
        if (h.isValidate() == true) {
            let o = h.GetPostData();
            o.ids = ids;
            h.Ajax('Order', 'Delery', o, (data) => {
                if (data.status == 200) {
                    h.MessageBox(data.message, FixedMessage.Result);
                    h.GoBack();
                }
                else {
                    h.Error(data.message, FixedMessage.Result);

                }

            });
        }
   
 
    }
    if (pageState.isLoaded == false) {
        serach();
        return <LoadingBar />
    }


    return <FromSubmit submitBev={submit}>
        <InputBox meta={DataClass.Order.DeleryTime} size="33%"></InputBox>
        <InputBox meta={DataClass.Order.DeleryStatus} size="33%"></InputBox>
        <InputBox meta={DataClass.Order.PostCode} size="33%"></InputBox>
        <InputBox meta={DataClass.Order.Code} size="33%"></InputBox>
        {
        pageState.isLoaded &&
        <ProTable rowNumbering={true} datasourcename="Orders" key={Date().toString()} Records={pageState.orders}>
            <Column columnName="selected" type={ColumnType.InputCheck} ></Column>
            <Column metaForDisplay={DataClass.OrderSerachReport.Id} />
            <Column metaForDisplay={DataClass.OrderSerachReport.CustomerName} />
            <Column metaForDisplay={DataClass.OrderSerachReport.OrderDate} />
                    <Column metaForDisplay={DataClass.OrderSerachReport.Descr} />
                    <Column metaForDisplay={DataClass.Order.TotalFactor} />
                    <Column metaForDisplay={DataClass.Order.PayAmount} />
                    <Column metaForDisplay={DataClass.Order.PayStatus} />
                    <Column metaForDisplay={DataClass.OrderSerachReport.SerailStatus} />
                    <Action caption="نسخه چاپی" Icon="Print" type="function" targetFun={Print} />
                    <Action caption="ویرایش" Icon="Edit" type="Link" pageName="/Sell/Edit" columnName="id" />

                </ProTable>
    }</FromSubmit>;


}
function SetPayStatus() {
    const [pageState, setState] = useState({ data: null, isLoaded: false});
    let id = useParams().id;

    const loadData = () => {
        let h = new Helper();
        h.Ajax('Order', 'GetPayInfo', { id: id },
            (data) => {
                setState({ data: data, isLoaded: true });
                setTimeout(() => { h.SetDataBack(data); }, 500);
            }


        );

    };
    const submit = () => {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == true) {
            let o = {  model:h.GetPostData() ,id:id };
            h.Ajax('Order', 'SetPayInfo', o, (data) => {
                h.MessageBox(data.message, 'نتیجه');
                if (data.status == 200) {
                    h.GoBack();
                }


            });

        }
     
    };


    if (pageState.isLoaded == false) {
        loadData();
        return LoadingBar();

    }




    let h = new Helper();
    return <FromSubmit submitBev={submit}>
    <FormDiv size='100%'>
            نام مشتری: {pageState.data.customerName} تاریخ سفارش : {pageState.data.orderDate} مبلغ کل فاکتور :{h.addCommas(pageState.data.totalFactor)}
        </FormDiv>

        <SelectBasic caption="وضعیت پرداخت" columnName="payStatus" mustFill={true}
            source={enums.PayStatus} size='33%' onChange={() => {
                let v = $('#txtpayStatus').val();
                switch (v) {
                    case '0':
                        $('#txtPayAmount').val(0);
                        break;
                    case '1':
                        $('#txtPayAmount').val(h.addCommas(pageState.data.totalFactor));
                        break;
                    case '2':
                        $('#txtPayAmount').val(h.addCommas(pageState.data.totalFactor));
                        break;
                    case '3':
                        $('#txtPayAmount').val(h.addCommas(pageState.data.totalFactor));
                        break;
                    default:
                        $('#txtPayAmount').val('');
                        break;
                }
               

            }}
         
        ></SelectBasic>
        <InputBox meta={DataClass.Order.PayDate} size='33%' />
        <InputBox meta={DataClass.Order.PayAmount} size='33%' />
        <InputBox meta={DataClass.Order.RefId} size='100%' />
        <InputBox meta={DataClass.Order.PayDescr} size='100%' />
        <br />
        چنانچه فعلا شماره پیگیری ندارید به جای کد پیگیری - درج نمائید
        <br/>

    </FromSubmit>
}



function OrderMamanget() {

 



    let status = useParams().status;
    const [pageState, orders] = useState({ orders: [], isLoaded: false, filter: '', pageTemplate: [], templateId: -1 });
    const [groupState, setGroupState] = useState({ groups: [], isLoaded: false ,curStatus:-1});
    if (pageState.isLoaded == false) {
        setTimeout(() => {
            $('#serachBar').hide();
            groupSet();
        }, 500);
        if (status != undefined) {
            setTimeout(() => {
                 
                showDetail(status);

            }, 500);
        }
     

    }
    if (status != groupState.curStatus) {
    
        setTimeout(() => {
            setGroupState({ curStatus: status, groups: groupState.groups, isLoaded:true });
            showDetail(status);
        }, 500);
    }

    const serach = () => {
        let h = new Helper();
        h.SaveState();
        let data = h.GetPostData();
        h.Ajax('Order', 'Serach', data, (data) => {
            orders({ orders: data, isLoaded: true, filter: '', pageTemplate: pageState.pageTemplate, templateId: pageState.templateId });
        
        });
    };
    const showDetail = (code) => {
        let h = new Helper();
        h.SaveState();
        let data = h.GetPostData();
        h.Ajax('Order', 'GroupDetail', {code:code}, (data) => {
            orders({ orders: data, isLoaded: true, filter: '', pageTemplate: pageState.pageTemplate, templateId: pageState.templateId });
            
        });
    };


    const groupSet = () => {
        let h = new Helper();
        h.SaveState();

        h.Ajax('Order', 'GroupStatus', {}, (data) => {
            setGroupState({ groups: data, isLoaded: true, curStatus: status });
        });
    };

    const UnPayed = () => {
        let h = new Helper();
        h.SaveState();
        let data = h.GetPostData();
        h.Ajax('Order', 'PayedNotFull', {  }, (data) => {
            orders({ orders: data, isLoaded: true, filter: '', pageTemplate: pageState.pageTemplate, templateId: pageState.templateId });

        });

    };
    const pageTemplateLoad = ()=>
    {
        let h = new Helper();
        h.SaveState();
     
        h.Ajax('FactorTemplate', 'List', {}, (data) => {
            let templateID = -1;
            if (data.length != 0) {
                templateID = data[0].id;
            }

            orders({ orders: pageState.orders, isLoaded: true, filter: '', pageTemplate: data, templateId: templateID });

        });
    }


    const Print = (record) => {
        window.open('/Order/ShowFactor/' + record.id + '?templateId=' + pageState.templateId);

    }
    const PrintFactor = (record) => {
        window.open('/Order/ShowFactor/' + record.id + '/' + pageState.templateId);

    }
    const GetDelevryInfo = (record)=>
    {
        let h = new Helper();
        h.Ajax('Order', 'Get', {id:record.id}, (data) => {
            h.MessageBox('زمان :' + data.order.deleryTime + '<br/>' +
                'وضعیت :' + h.GetCaptionFromEnum(enums.DeleryStatus, data.order.deleryStatus) + '<br/>'
                + 'کد مرسوله :' + data.order.postCode + '<br/>'
                + 'کد اعمال محصول :' + data.order.code + '<br/>'
                + 'نحوه تحویل :' + h.GetCaptionFromEnum(enums.DelveryMethod, data.order.delveryMethod) + '<br/>'
                + 'تحویل گیرنده :' + data.order.delveryPerson + '<br/>'
           ,'' )
        });
    };


    const PrintAll = ()=>
    {
        var h = new Helper();
        var recs = h.GetRecordWithCircita(pageState.orders, 'selected', true);
        for (let i = 0; i < recs.length; i++) {
            Print(recs[i]);
        }
    }
    const Delete=(record)=>{
        let hlp = new Helper();
    
        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('Order', 'Delete', { id: record.id }, function (data) {
                serach();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }
    
    const UnDelver = (record) => {
        let hlp = new Helper();

        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('Order', 'BackFromDelevry', { id: record.id }, function (data) {
                serach();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }

    const SendSms = (record) => {
        let hlp = new Helper();

        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('Order', 'SendSms', { id: record.id }, function (data) {
               
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }

    const SharkLink = (record) => {
        let hlp = new Helper();

 
            hlp.Ajax('Order', 'GetSmsContext', { id: record.id }, function (data) {

                hlp.shareText(data.message);
            });
        
    }
    const CheckPay = (record) => {
        let hlp = new Helper();

        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('Order', 'CheckPayment', { id: record.id }, function (data) {
                serach();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }
    const CancelLoan = (record) => {
        let hlp = new Helper();

        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('Loan', 'CancelLoan', { orderId: record.id }, function (data) {
                serach();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }
    
    const UpdatePrice = (record) => {
        let hlp = new Helper();

        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('Order', 'UpdatePrice', { id: record.id }, function (data) {
                serach();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }

    if (pageState.pageTemplate.length == 0) {
        pageTemplateLoad();
    }


    return <FromBasic>
        <form className="row g-3" id="serachBar"  >
            <DropDownBox caption="نام مشتری" entity="OrderCustomer" size="33%" includeAll={true} columnName="CustomerId" />
            <DropDownBox caption="نام کالا" entity="OrderItemProduct" size="33%" includeAll={true} columnName="ProductId" />
            <InputTextBox caption="سریال" columnName="Serail" model="Serial" size="33%"></InputTextBox>
            <InputTextBox caption="از تاریخ" columnName="StartDate" model="StartDate" size="33%" customHelper={CustomHelper.isDate}></InputTextBox>
            <InputTextBox caption="تا تاریخ" columnName="EndDate" model="EndDate" size="33%" customHelper={CustomHelper.isDate}></InputTextBox>
            <SelectBasic caption="وضعیت مالی" columnName="PayStatus" model="payStatus" includeAll={true} source={enums.PayStatus} size="33%" ></SelectBasic>
            <center>
                <SimpleButton onClick={serach} title="جست و جو " Icon="View"></SimpleButton>
            </center>
        </form>
           <center>

            <AddButton entity='Sell' ></AddButton>
            {groupState.groups.map((v) => {
                return <SimpleButton onClick={() => {
                    showDetail(v.code);
                }} title={v.title +"(" + v.count +")"} Icon="View"></SimpleButton>;
            })}
            


            <SimpleButton onClick={() => { $('#serachBar').toggle(250); } } title="جستجوی پیشرفته" Icon="View"></SimpleButton>
            <SimpleButton onClick={PrintAll} title='چاپ گروهی' Icon="Print"></SimpleButton>
         
        </center>
        <legend title="انتخاب سربرگ">
        
            {pageState.pageTemplate.map((v) => {
                return <SimpleButton Icon={pageState.templateId == v.id ? 'Yes' : undefined} title={v.name} onClick={() => {
                    let state = pageState;
                    state.templateId = v.id;
                    orders({
                        filter: pageState.filter
                        , orders: pageState.orders,
                        isLoaded: true, pageTemplate: pageState.pageTemplate,templateId:v.id
                    });
                    
                }}></SimpleButton>
            })}
        </legend>
        {pageState.isLoaded &&
            <ProTable rowNumbering={true} datasourcename="Orders" key={Date().toString()} Records={pageState.orders}>
                <Column columnName="selected" type={ColumnType.InputCheck} ></Column>
                <Column metaForDisplay={DataClass.OrderSerachReport.Id} />
                <Column metaForDisplay={DataClass.OrderSerachReport.FactorType} />

                <Column metaForDisplay={DataClass.OrderSerachReport.CustomerName} />
                <Column metaForDisplay={DataClass.OrderSerachReport.OrderDate} />
                <Column metaForDisplay={DataClass.OrderSerachReport.TotalFactor} />
                <Column metaForDisplay={DataClass.OrderSerachReport.Descr} />
                <Column metaForDisplay={DataClass.OrderSerachReport.PayStatus} />
                <Column metaForDisplay={DataClass.OrderSerachReport.PayDate} />
                <Column metaForDisplay={DataClass.OrderSerachReport.PayAmount} />
                <Column metaForDisplay={DataClass.OrderSerachReport.PayDescr} />
                <Column metaForDisplay={DataClass.OrderSerachReport.UserNameDisplay} />
             
                <Column metaForDisplay={DataClass.OrderSerachReport.FactorState} />
                {window.targetCallback != undefined &&
                    <Action caption="انتخاب" type="function" targetFun={(r) => {
                        window.targetCallback(r.id);
                        window.close();

                    }} />}
                <Action caption="ویرایش" Icon="Edit" type="Link" pageName="/Sell/Edit" columnName="id" />
                 
                <Action caption="نسخه چاپی" Icon="Print" type="function" targetFun={Print} />
                <Action caption="نسخه فاکتور" Icon="Print" type="function" targetFun={PrintFactor} />
                <Action caption="تعیین تکلیف مالی" Icon="Wallet" type="Link" pageName="/Sell/SetPayInfo" columnName="id" />
                <Action caption="ضمیمه" Icon="Cat" type="Link" pageName="/Attachs/Order" columnName="id" />
                <Action caption="ارسال پیامک" type="function" targetFun={SendSms} />
                <Action caption="به اشتراک گذاری لینک" type="function" targetFun={SharkLink} />

                <Action caption="بررسی وصولی پرداخت الکترونیک" type="function" targetFun={CheckPay} />
                <Action caption="ثبت سریال" type="Link" showCond={(r) => { return r.factorState == 1 }} pageName="/Sell/InputSerail" columnName="id" />
                <Action caption="حذف" type="function" targetFun={Delete} />
                <Action caption="اطلاعات تحویل" type="function" showCond={(r) => { return r.factorState == 3 }} targetFun={GetDelevryInfo} />
                <Action caption="برگشت از تحویل" type="function" showCond={(r) => { return r.factorState == 3 }} targetFun={UnDelver} />
                <Action caption=" تحویل" type="Link" showCond={(r) => {return r.factorState==2 }} pageName="/Sell/StartDel" columnName="id" />
                <Action caption="تقسیط" type="Link" showCond={(r) => { return r.payStatus == 0 }} pageName="/CreateLoan" columnName="id" />
                <Action caption="برگشت از تقسیط" type="function" showCond={(r) => { return r.payStatus == 6 }} targetFun={CancelLoan} />
                <Action caption="اقساط تقسیط" type="Link" showCond={(r) => { return r.payStatus == 6 }} pageName="/LoanDetail" columnName="id" />
          
                   
                

            </ProTable>    
        
        
        }

    </FromBasic>

}



function DetailSerach() {


    const [pageState, orders] = useState({ orders: [], isLoaded: false, filter: '', pageTemplate: [], templateId: -1 });


    const serach = () => {
        let h = new Helper();
        h.SaveState();
        let data = h.GetPostData();
        h.Ajax('Order', 'SerachDetail', data, (data) => {
            orders({ orders: data, isLoaded: true, filter: '', pageTemplate: pageState.pageTemplate, templateId: pageState.templateId });

        });
    };
     
   

    return <FromBasic>
        <DropDownBox caption="نام مشتری" entity="OrderCustomer" size="33%" includeAll={true} columnName="CustomerId" />
        <DropDownBox caption="نام کالا" entity="OrderItemProduct" size="33%" includeAll={true} columnName="ProductId" />
        <InputTextBox caption="سریال" columnName="Serail" model="Serial" size="33%"></InputTextBox>
        <InputTextBox caption="از تاریخ" columnName="StartDate" model="StartDate" size="50%" customHelper={CustomHelper.isDate}></InputTextBox>
        <InputTextBox caption="تا تاریخ" columnName="EndDate" model="EndDate" size="50%" customHelper={CustomHelper.isDate}></InputTextBox>
        <center>
            <SimpleButton onClick={serach} title="جست و جو " Icon="View"></SimpleButton>
               </center>
      
        {pageState.isLoaded &&
            <ProTable rowNumbering={true} datasourcename="Orders" key={Date().toString()} Records={pageState.orders}>
                <Column metaForDisplay={DataClass.DetailReport.Id} />
                <Column metaForDisplay={DataClass.DetailReport.ProductName} />
                <Column metaForDisplay={DataClass.DetailReport.CustomerName} />
                <Column metaForDisplay={DataClass.DetailReport.OrderId} />
                <Column metaForDisplay={DataClass.DetailReport.OrderDate} />
                <Column metaForDisplay={DataClass.DetailReport.Descr} />
                <Column metaForDisplay={DataClass.DetailReport.StartGranteyDate} />
                <Column metaForDisplay={DataClass.DetailReport.EndGranteyDate} />
                <Column metaForDisplay={DataClass.DetailReport.Serial} />



            </ProTable>


        }

    </FromBasic>

}





export function SerailBySerail(props) {
    const [pageState, currentState] = useState({ result:null, isLoaded: false, filter: '' });

    const serach = () => {
        let h = new Helper();
        h.SaveState();
        let data = h.GetPostData();
        h.Ajax('Order', 'GetSerail', data, (data) => {
            if (data.message != undefined) {
                h.Alert(data.message);
                return;
            }

            currentState({ result: data, isLoaded: true, filter: '' });
        });
    };


    return <FromBasic>
        <InputBox meta={DataClass.OrderItem.Serial}></InputBox>
        <center>
            <SimpleButton onClick={serach} title="جست و جو " Icon="View"></SimpleButton>
           
        </center>
        {pageState.result != null && < div >
            {props.hideDetail == undefined && <div> < hr />
                مشخصات خریدار:<br />
                {pageState.result.customer.name} <br/>
                {pageState.result.customer.mobile} <br />
                {pageState.result.customer.address} <br />

           
            <hr/></div>}
                مشخصات کالا:<br />
                {pageState.result.product.name} <br />
            {pageState.result.serial} <br />
            دوره گارانتی {pageState.result.startGranty} الی {pageState.result.endGranty}
          <br/>  وضعیت گارانتی: {pageState.result.granteyStatus}
        </div>}
    </FromBasic>;
}
export function SerailSerachForClient() {


   return  <div style={{ color: 'black' }}>
            <div style={{ position: 'fixed', color:'black', background: 'url(/backgrounds/Bk2.jpg)', backgroundSize: 'cover', left: '0px', top: '0px', zIndex: '-10', bottom: '0px', right: '0px' }} />
            <center>
                <img alt={window.config.AppTitle} src="/Icons/Logo.png"></img>
              
           <div className="col-sm-5" style={{ background: 'white', borderRadius: '5px', boxShadow: '1px 1px 3px black' }} role="alert">
               <SerailBySerail hideDetail={true }></SerailBySerail>
               <br />
               <br/>
                </div>
       </center>
       <Model />
       <Confirm />
                </div >

}




/* ویرایش */
function EditFactorTemplate() {
    const queryS = useParams();
    return <AddFactorTemplate id={queryS.id} />
}

/* درج و و یرایش رکورد */


export class AddFactorTemplate extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.submit = this.submit.bind(this);
    }
    submit() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let id = (cmd.id == undefined ? -1 : cmd.id);
        let o = h.GetPostData();
        h.Ajax('FactorTemplate', (cmd.id == '-1' ? 'Insert' : 'Update'), { Model: o, id: id }, function (data) {
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                h.GoBack();
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
    }
    componentDidMount() {
        let h = new Helper();
        if (this.id != -1) {
            h.Ajax('FactorTemplate', 'Get', { id: this.id }, function (data) {
                h.SetDataBack(data);
            });


        }
    }
    render() {
        return <FromSubmit submitBev={this.submit}>
            <InputBox meta={DataClass.FactorTemplate.name} size='100%' />
            <InputBox meta={DataClass.FactorTemplate.Header} size='100%' customHelper={CustomHelper.Html} />

            <InputBox meta={DataClass.FactorTemplate.Footer} size='100%' customHelper={CustomHelper.Html} />
       

        </FromSubmit>

    }

}

export class FactorTemplateMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });
        this.Delete = this.Delete.bind(this);
        this.Refersh = this.Refersh.bind(this);

    }

    Delete(record) {
        let hlp = new Helper();
        let cmd = this;
        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('FactorTemplate', 'Delete', { Model: record }, function (data) {
                cmd.componentDidMount();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }

    Refersh() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('FactorTemplate', 'List', {}, function (data) {
            cmd.setState({ isLoaded: true, Records: data });
        });
    }

    componentDidMount() {
        this.Refersh();
    }

    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle=''>
                <AddButton title='' entity='FactorTemplate' /> <ProTable Records={this.state.Records} datasourcename='FactorTemplates'>
                    <Column metaForDisplay={DataClass.FactorTemplate.id} />
                    <Column metaForDisplay={DataClass.FactorTemplate.name} />
                   
                    <Action caption="ویرایش" Icon="Edit" type="Link" pageName="/FactorTemplate/Edit" columnName="id" />


                    <Action caption="حذف" Icon="Delete" type="function" targetFun={this.Delete} />




                </ProTable>
            </FromBasic>
        }
    }



}


/* دریافت تمامی رکورد ها */
  



/* ویرایش */
function EditStroageTransaction() {
    const queryS = useParams();
    return <AddStroageTransaction id={queryS.id} />
}

/* درج و و یرایش رکورد */


export class AddStroageTransaction extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.submit = this.submit.bind(this);
    }
    submit() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let id = (cmd.id == undefined ? -1 : cmd.id);
        let o = h.GetPostData();
        h.Ajax('StroageTransaction', (cmd.id == '-1' ? 'Insert' : 'Update'), { Model: o, id: id }, function (data) {
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                h.GoBack();
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
    }
    componentDidMount() {
        let h = new Helper();
        if (this.id != -1) {
            h.Ajax('StroageTransaction', 'Get', { id: this.id }, function (data) {
                h.SetDataBack(data);
            });


        }
    }
    render() {
        return <FromSubmit submitBev={this.submit}>
 
            <InputBox meta={DataClass.StroageTransaction.TransactionDate} size='50%' />
            <InputBox meta={DataClass.StroageTransaction.ProductId} size='50%' />
 
            <InputBox meta={DataClass.StroageTransaction.TransactionType} size='50%' />
            <InputBox meta={DataClass.StroageTransaction.TransactionCount} size='50%' />
            
            <InputBox meta={DataClass.StroageTransaction.Descr} size='100%' />
 

        </FromSubmit>

    }

}



function StroageTransactionMgt() {


    const [pageState, setState] = useState({ transactions: [], isLoaded: false, filter: '' });


    const serach = () => {
        let h = new Helper();
        h.SaveState();
        let data = h.GetPostData();
        h.Ajax('StroageTransaction', 'Serach', data, (data) => {
            setState({ orders: data, isLoaded: true, filter: '', pageTemplate: pageState.pageTemplate, templateId: pageState.templateId });

        });
    };
    


    

    const Delete = (record) => {
        let hlp = new Helper();

        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('StroageTransaction', 'Delete', { id: record.id }, function (data) {
                serach();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }
 


    return <FromBasic>
        
        <DropDownBox caption="نام کالا" entity="OrderItemProduct" size="50%" includeAll={true} columnName="ProductId" />
        <SelectBasic caption="نوع تراکنش" columnName="transactionType" includeAll="true" size="50%" source={enums.TransactionType} />
        <InputTextBox caption="از تاریخ" columnName="StartDate" model="StartDate" size="50%" customHelper={CustomHelper.isDate}></InputTextBox>
        <InputTextBox caption="تا تاریخ" columnName="EndDate" model="EndDate" size="50%" customHelper={CustomHelper.isDate}></InputTextBox>
        <center>
            <SimpleButton onClick={serach} title="جست و جو " Icon="View"></SimpleButton>
            <AddButton entity='StroageTransaction' ></AddButton>
        </center>
       
        {pageState.isLoaded &&
            <ProTable datasourcename="Orders" key={Date().toString()} Records={pageState.orders}>
                <Column metaForDisplay={DataClass.StorageTransactionSerachResult.Id} />
                <Column metaForDisplay={DataClass.StorageTransactionSerachResult.ProductName} />
                <Column metaForDisplay={DataClass.StorageTransactionSerachResult.TransactionCount} />
                <Column metaForDisplay={DataClass.StorageTransactionSerachResult.TransactionType} />
                <Column metaForDisplay={DataClass.StorageTransactionSerachResult.TransactionDate} />
                <Action caption="ویرایش" Icon="Edit" type="Link" pageName="/StroageTransaction/Edit" columnName="id" />

      
                <Action caption="حذف" Icon="Delete" type="function" targetFun={Delete} />



            </ProTable>


        }

    </FromBasic>

}


export class StorageReport extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });
     
        this.Refersh = this.Refersh.bind(this);

    }

    Refersh() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('StroageTransaction', 'Count', {}, function (data) {
            cmd.setState({ isLoaded: true, Records: data });
        });
    }

    componentDidMount() {
        this.Refersh();
    }

    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle=''>
                  <ProTable Records={this.state.Records} datasourcename='Products'>
                    <Column metaForDisplay={DataClass.StroageResult.ProductId} />
                    <Column metaForDisplay={DataClass.StroageResult.ProductName} />
                    <Column metaForDisplay={DataClass.StroageResult.Count} />
                    

                </ProTable>
            </FromBasic>
        }
    }



}

export class AddDirectPay extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.submit = this.submit.bind(this);
    }
    submit() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let id = (cmd.id == undefined ? -1 : cmd.id);
        let o = h.GetPostData();
        h.Ajax('DirectPay', (cmd.id == '-1' ? 'Insert' : 'Update'), { Model: o, id: id }, function (data) {
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                h.GoBack();
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
    }
    componentDidMount() {
        let h = new Helper();
        if (this.id != -1) {
            h.Ajax('DirectPay', 'Get', { id: this.id }, function (data) {
                h.SetDataBack(data);
            });


        }
    }
    render() {
        return <FromSubmit submitBev={this.submit}>
         
         
            <InputBox meta={DataClass.DirectPay.Mobile} size='50%' />
            <DropDownBox size="50%"  columnName="ProductId" entity="Product" caption="محصول" mustFill="Yes" onChange={() => {
                let h = new Helper();
                h.Ajax('DirectPay', 'GetProduct', { id: $('#txtProductId').val() }, (data) => {
                    $('#txtTitle').val(data.name);
                    $('#txtAmount').val(h.addCommas( data.priceInRail));
                }
                 

                )
            }}></DropDownBox>
             <InputBox meta={DataClass.DirectPay.Amount} size='50%' />
            <InputBox meta={DataClass.DirectPay.Title} size='50%' />
            <InputBox meta={DataClass.DirectPay.DescriptionCustomer} size='50%' />
            <InputBox meta={DataClass.DirectPay.DescriptionUser} size='50%' />

        </FromSubmit>

    }

}


export function StartPay(props) {


    const id = useParams().id;
    const [pageState, loadState] = useState({ data: null });

    const submit = () => {
        let h = new Helper();
        
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
       
        let o = h.GetPostData();
        h.Ajax('DirectPay', 'StartPay', { Model: o, id: id }, function (data) {
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                window.open("/dpn/" + data.refId);
                h.GoBack();
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
    };
    const loadData = () => {
        let h = new Helper();
        if (id != -1) {
            h.Ajax('DirectPay', 'Get', { id: id }, function (data) {
                loadState({ data: data });
                setTimeout(() => { h.SetDataBack(data); }, 500);
            });


        }
    };

    if (pageState.data == null) {
        loadData();
        return <LoadingBar />;
    }
    let data = pageState.data;
    var helper= new Helper();
    return <FromSubmit submitBev={submit}>
        <div style={{ margin:'5px' }}>
    
    
         
            <br />
           
            <b>عنوان :  </b>{data.title} <br />
            <b>مبلغ :  </b>{helper.addCommas(data.amount)} <br />
            توضیحات:
            {data.descriptionCustomer}
        </div>
       
   
        <InputBox meta={DataClass.DirectPay.FullName} size='50%' />
        <InputBox meta={DataClass.DirectPay.UserId} size='50%' />


    </FromSubmit>;

}
export class DirectPayMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [], Grouped: [] });
        this.Confirm = this.Confirm.bind(this);
        this.Delete = this.Delete.bind(this);
        this.Refersh = this.Refersh.bind(this);
        this.Import = this.Import.bind(this);
        this.mode=-1;
        if(props.mode!=undefined)
        {
            this.mode=props.mode;
        }
    }
    Delete(record) {
        let hlp = new Helper();
        let cmd = this;
        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('DirectPay', 'Delete', { Model: record }, function (data) {
                cmd.componentDidMount();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }
    Confirm(record) {
        let hlp = new Helper();

        let cmd = this;
        hlp.ConfirmAction(FixedMessage.AreYouSure, "", () => {
            setTimeout(() => { this.final(record,cmd) }, 500);
        }
        );
  
    }
    final(record,ref) {
        let hlp = new Helper();
        hlp.ConfirmAction("آیا پیامک ارسال شود؟", '', function () {
            ref.SendConfrim(record.id, true,ref);

        }, () => {
            ref.SendConfrim(record.id, false,ref);
        });


    }
    SendConfrim(id, sendSms,ref) {
 
        let cmd = ref;
        let h = new Helper();
        h.Ajax('DirectPay', 'Done', { id: id, sendSms: sendSms }, function (data) {
            h.Alert(data.message, '');
            ref.Refersh(2);
        });
    }
    CheckPay(record,ref) {

        let cmd = ref;
        let h = new Helper();
        h.Ajax('DirectPay', 'CheckPay', { id: record.id}, function (data) {
            h.Alert(data.message, '');
            ref.Refersh(2);
        });
    }

    Refersh(status) {
        let cmd = this;
        let h = new Helper();
        h.Ajax('DirectPay', 'List', { status: status }, function (data) {
            cmd.setState({ isLoaded: true, Records: data, Grouped: cmd.state.Grouped });
        });
    }

    Reload(status) {
        if (status == "در حال انتظار پرداخت") {
            this.Refersh(0);
        }
        if (status == "در حال انجام") {
            this.Refersh(2);
        }
           if (status == "مختومه") {
            this.Refersh(3);
        }
    }
    SharkLink(record)  {
        let hlp = new Helper();


        hlp.Ajax('DirectPay', 'GetSmsContext', { id: record.id }, function (data) {

            hlp.shareText(data.message);
        });

    }


    GroupSet() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('DirectPay', 'Grouped', {}, function (data) {
            cmd.setState({ isLoaded: true, Records: cmd.state.Records, Grouped: data });
        });
    }
    componentDidMount() {
        if (this.mode == -1) {
            this.Refersh(2);
            this.GroupSet();
        }
        else {
            this.Refersh(this.mode);
            this.GroupSet();
        }
    
    }
    ClearOld() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('DirectPay', 'DeleteOlds', {}, function (data) {
            h.Alert(data.message);
            cmd.componentDidMount();
        });
    }




    Import() {
        let cx = document.getElementById('txtFile');
        let formData = new FormData();
        let cmd = this;
      
       
            formData.append('file', cx.files[0], cx.value);
     
        let h = new Helper();
        h.AjaxForUpload('DirectPay', 'Import', formData, (data) => {
            h.Alert(data.message.replace(/\r\n/g, '<br/>'));
            h.download(data.message, 'result.txt');
            if (data.status == 200) {
                $('#txtFile').val(null);
                cmd.Refersh();
            }

        });


    }
    render() {
        let h = new Helper();
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle=''>
            <center>
                <AddButton title='' entity='DirectPay' />
                    {this.state.Grouped.map(((v) => {
                        return <SimpleButton title={v.status + "(" + v.count + ")"}
                            onClick={() => { this.Reload(v.status) }}
                        ></SimpleButton>

                    }))}
                    <br />
                    دریافت از اکسل :
                    <input id="txtFile" type="file" />
                    <SimpleButton onClick={this.Import} title="ارسال فایل"></SimpleButton>
                    <a href="/DirectPayTemp.xlsx" download="Temp.xlsx" >
                    دریافت فایل نمومه
                    </a>
                    <SimpleButton onClick={this.ClearOld} title="پاکسازی"></SimpleButton>
                </center>

                <ProTable Records={this.state.Records} key={new Date().toString()} datasourcename='DirectPays'>


                    <Column metaForDisplay={DataClass.DirectPay.id} />
                    <Column metaForDisplay={DataClass.DirectPay.Title} />
                    <Column metaForDisplay={DataClass.DirectPay.DescriptionCustomer} />
                    <Column metaForDisplay={DataClass.DirectPay.DescriptionUser} />
                    <Column metaForDisplay={DataClass.DirectPay.FullName} />
                        <Column metaForDisplay={DataClass.DirectPay.UserId} />

                    <Column metaForDisplay={DataClass.DirectPay.Mobile} />
              
                    <Column metaForDisplay={DataClass.DirectPay.Amount} />
            
                    <Column metaForDisplay={DataClass.DirectPay.Status} />
         
                    <Column metaForDisplay={DataClass.DirectPay.UserNameDisplay} />
                    <Action caption="اشتراک گذاری پیامک" Icon="Yes" type="function" targetFun={this.SharkLink} />

                    <Action caption="مختومه" Icon="Yes" type="function" targetFun={this.Confirm} />
                    <Action caption="مختومه و ثبت تحویل فاکتور" type="Link" columnName='id' pageName="/DirectPays/SetDel" />

                    <Action caption="استعلام وصولی" Icon="Yes" type="function" targetFun={this.CheckPay} />
                    <Action caption="حذف" Icon="Delete" type="function" targetFun={this.Delete} />
  

 


                </ProTable>
            </FromBasic>
        }
    }



}

class ProdcutCategoryMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { isLoaded: false, Record: [] };
        this.submit = this.submit.bind(this);
    }
    componentDidMount() {
        let cmd = this;
        let hlp = new Helper();
        hlp.Ajax("ProdcutCategory", "List", {}, function (datas) {
            cmd.setState({ isLoaded: true, Records: datas });

        }, function () { });

    }
    submit() {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let data = h.GetDataGrouped(window.ProdcutCategorys);
        h.Ajax('ProdcutCategory', 'SaveBatch', { Inserted: data[RowState.Inserted], Updated: data[RowState.Changed], deleted: data[RowState.Deleted] }
            , function (data) {
                h.MessageBox(FixedMessage.NoProblem, FixedMessage.Result);
                h.GoBack();
            },
        )
    }
    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();
        }
        else {
            return <FromSubmit SubmitButtonOnTop={true} submitBev={this.submit} >
                <ProTable datasourcename='ProdcutCategorys' Records={this.state.Records} Insertable={true} Deleteable={true}>
                    <Column metaForDisplay={DataClass.ProdcutCategory.id} />
                    <Column metaForInput={DataClass.ProdcutCategory.name} />

                </ProTable>

            </FromSubmit>

        }

    }


} class CustomeGroupMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { isLoaded: false, Record: [] };
        this.submit = this.submit.bind(this);
    }
    componentDidMount() {
        let cmd = this;
        let hlp = new Helper();
        hlp.Ajax("CustomeGroup", "List", {}, function (datas) {
            cmd.setState({ isLoaded: true, Records: datas });

        }, function () { });

    }
    submit() {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let data = h.GetDataGrouped(window.CustomeGroups);
        h.Ajax('CustomeGroup', 'SaveBatch', { Inserted: data[RowState.Inserted], Updated: data[RowState.Changed], deleted: data[RowState.Deleted] }
            , function (data) {
                h.MessageBox(FixedMessage.NoProblem, FixedMessage.Result);
                h.GoBack();
            },
        )
    }
    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();
        }
        else {
            return <FromSubmit SubmitButtonOnTop={true} submitBev={this.submit} >
                <ProTable datasourcename='CustomeGroups' Records={this.state.Records} Insertable={true} Deleteable={true}>
                    <Column metaForDisplay={DataClass.CustomeGroup.id} />
                    <Column metaForInput={DataClass.CustomeGroup.name} />
                    <Column metaForInput={DataClass.CustomeGroup.DiscountPercent} />

                </ProTable>

            </FromSubmit>

        }

    }


}

function SetDirectPayOrderDel(props) {
    let id = useParams().id;

    const submit = () => {
        let h = new Helper();
        var data= h.GetPostData();
        data.id = id;
        data.sendSms = true;
        data.setDelevryMode = true;
        h.Ajax('DirectPay', 'Done', data, (result) => {
            if (result.status == 200) {
                h.MessageBox(result.message, FixedMessage.Result);
                h.GoBack();
            }
            else {
                h.Error(result.message, FixedMessage.Result);

            }

        });
    };


    return <FromSubmit submitBev={submit}>
        <InputBox meta={DataClass.Order.PostCode} size="50%" />
        <InputBox meta={DataClass.Order.Code} size="50%" />
    </FromSubmit>;
}

export class CustomeRemainFactorDtoMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });

        this.Refersh = this.Refersh.bind(this);

    }



    Refersh() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('OrderReport', 'CustomersRemain', {}, function (data) {
            cmd.setState({ isLoaded: true, Records: data });
        });
    }

    componentDidMount() {
        this.Refersh();
    }

    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle=''>
                <ProTable Records={this.state.Records} datasourcename='CustomeRemainFactorDtos'>
                    <Column metaForDisplay={DataClass.CustomeRemainFactorDto.id} />
                    <Column metaForDisplay={DataClass.CustomeRemainFactorDto.CustomerName} />
                    <Column metaForDisplay={DataClass.CustomeRemainFactorDto.Remain} />






                </ProTable>
            </FromBasic >
        }

    }
}


export class ProductSellReport extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { records: [] }
        this.serach = this.serach.bind(this);
 
    }

    serach() {
        let h = new Helper();
        let cmd = this;

        h.Validate();
        if (h.isValidate()) {
            let d = h.GetPostData();
            h.Ajax('OrderReport', 'SellReport', d, function (data) {
                cmd.setState({ records: data });
            });

        }

    }

    
    showDetail(r) {
        let h = new Helper();
        h.MessageBox("خطا :" + r.error);
    }
    render() {
        return <FromBasic >
            <InputTextBox size='50%' caption="از تاریخ" mustFill columnName="start" model="start" customHelper={CustomHelper.isDate}></InputTextBox>
            <InputTextBox size='50%' caption="تا تاریخ" mustFill columnName="end" model="end" customHelper={CustomHelper.isDate}></InputTextBox>

           
            <center>
                <SimpleButton title="نمایش" onClick={this.serach} Icon="View" ></SimpleButton>
            </center>
            <ProTable datasourcename="record" Records={this.state.records}>
                <Column metaForDisplay={DataClass.ProductSellReport.id} />
                <Column metaForDisplay={DataClass.ProductSellReport.ProductName} />
                <Column metaForDisplay={DataClass.ProductSellReport.TotalPrice} />
                <Column metaForDisplay={DataClass.ProductSellReport.Count} />
             
            </ProTable>
        </FromBasic>;
    }
}



export class UnitPriceCheck extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { records: [] }
        this.serach = this.serach.bind(this);

    }

    serach() {
        let h = new Helper();
        let cmd = this;

        h.Validate();
        if (h.isValidate()) {
            let d = h.GetPostData();
            h.Ajax('OrderReport', 'UnitPriceCheck', d, function (data) {
                cmd.setState({ records: data });
            });

        }

    }


    showDetail(r) {
        let h = new Helper();
        h.MessageBox("خطا :" + r.error);
    }
    render() {
        return <FromBasic >
            <InputTextBox size='50%' caption="از تاریخ" mustFill columnName="start" model="start" customHelper={CustomHelper.isDate}></InputTextBox>
            <InputTextBox size='50%' caption="تا تاریخ" mustFill columnName="end" model="end" customHelper={CustomHelper.isDate}></InputTextBox>


            <center>
                <SimpleButton title="نمایش" onClick={this.serach} Icon="View" ></SimpleButton>
            </center>
            <ProTable datasourcename="record" rowFormating={(r) => {
               
                if (r.unitPrice < r.targetPrice) {
                
                    return 'bgHigh';
                }
                else {
                   
                    return 'bgGreen';
                }
            }} Records={this.state.records}>
                <Column metaForDisplay={DataClass.UnitPriceCheck.id} />
                <Column metaForDisplay={DataClass.UnitPriceCheck.ProductName} />
                <Column metaForDisplay={DataClass.UnitPriceCheck.Count} />
                <Column metaForDisplay={DataClass.UnitPriceCheck.TotalPrice} />
                <Column metaForDisplay={DataClass.UnitPriceCheck.UnitPrice} />
                <Column metaForDisplay={DataClass.UnitPriceCheck.TargetPrice} />
                <Column metaForDisplay={DataClass.UnitPriceCheck.OrderId} />
                <Column metaForDisplay={DataClass.UnitPriceCheck.CustomerName} />
                <Column metaForDisplay={DataClass.UnitPriceCheck.OrderDate} />

            </ProTable>
        </FromBasic>;
    }
}



export class GroupedSellReport extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { records: [] }
        this.serach = this.serach.bind(this);

    }

    serach() {
        let h = new Helper();
        let cmd = this;

        h.Validate();
        if (h.isValidate()) {
            let d = h.GetPostData();
            h.Ajax('OrderReport', 'SellReportGrouped', d, function (data) {
                cmd.setState({ records: data });
            });

        }

    }


    showDetail(r) {
        let h = new Helper();
        h.MessageBox("خطا :" + r.error);
    }
    render() {
        return <FromBasic >
            <InputTextBox size='50%' caption="از تاریخ" mustFill columnName="start" model="start" customHelper={CustomHelper.isDate}></InputTextBox>
            <InputTextBox size='50%' caption="تا تاریخ" mustFill columnName="end" model="end" customHelper={CustomHelper.isDate}></InputTextBox>


            <center>
                <SimpleButton title="نمایش" onClick={this.serach} Icon="View" ></SimpleButton>
            </center>
            <ProTable datasourcename="record" Records={this.state.records}>
                <Column metaForDisplay={DataClass.GroupedSellReport.CategoryName} />
                <Column metaForDisplay={DataClass.GroupedSellReport.userName} />
                <Column metaForDisplay={DataClass.GroupedSellReport.Count} />
                <Column metaForDisplay={DataClass.GroupedSellReport.TotalPrice} />
            </ProTable>
        </FromBasic>;
    }
}




export function SetDelverSingle(props) {
    let id = useParams().id;
    const submit = () => {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == true) {
            let obj = h.GetPostData();
            obj.ids = [id];
            h.Ajax('Order', 'Delery', obj, (data) => {
                if (data.status == 200) {
                    h.GoBack();
                }
                h.MessageBox(data.message);
            });
        }
    };

    return <FromSubmit submitBev={submit}>
        <InputBox meta={DataClass.Order.DeleryTime} />
        <InputBox meta={DataClass.Order.DelveryMethod} />
        <InputBox meta={DataClass.Order.DelveryPerson} />
        <InputBox meta={DataClass.Order.PostCode} />
        <InputBox meta={DataClass.Order.Code} />
    </FromSubmit>
}



export class CheckForPay extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });
        this.Delete = this.Delete.bind(this);
        this.Refersh = this.Refersh.bind(this);

    }

    Delete(record) {
        let hlp = new Helper();
        let cmd = this;
        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('OrderSerachReport', 'Delete', { Model: record }, function (data) {
                cmd.componentDidMount();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }

    Refersh() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('Order', 'NeedForCheck', {}, function (data) {
            cmd.setState({ isLoaded: true, Records: data });
        });
    }

    componentDidMount() {
        this.Refersh();
    }
    confirm (status)  {
        var h = new Helper();
        var ids = [];
        var recs = h.GetRecordWithCircita(window.OrderSerachReports, 'selected', true);
        for (let i = 0; i < recs.length; i++) {
            ids.push(recs[i].id);
        }
        h.Validate();
        if (h.isValidate() == true) {
            let o = h.GetPostData();
            o.ids = ids;
            o.confirmStatus = status;
            h.ConfirmAction(FixedMessage.AreYouSure, "", () => {
                h.Ajax('Order', 'SetConfirm', o, (data) => {
                    if (data.status == 200) {
                        h.MessageBox(data.message, FixedMessage.Result);
                        h.GoBack();
                    }
                    else {
                        h.Error(data.message, FixedMessage.Result);

                    }

                });
            });
        }


    }
    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle=''>
                <center>
                    <SimpleButton title="تایید" onClick={() => {
                        this.confirm(1);
                    }}></SimpleButton>
                    <SimpleButton title="عدم تایید" onClick={() => {
                        this.confirm(2);
                    }}></SimpleButton>
</center>
                <ProTable Records={this.state.Records} datasourcename='OrderSerachReports'>
                    <Column columnName="selected" type={ColumnType.InputCheck} ></Column>
                 
                    <Column metaForDisplay={DataClass.OrderSerachReport.CustomerName} />
                    <Column metaForDisplay={DataClass.OrderSerachReport.OrderDate} />
                    <Column metaForDisplay={DataClass.OrderSerachReport.Descr} />
                    
                    <Column metaForDisplay={DataClass.OrderSerachReport.PayStatus} />
                   
                    <Column metaForDisplay={DataClass.OrderSerachReport.PayDate} />
                    <Column metaForDisplay={DataClass.OrderSerachReport.PayDescr} />
                  
                    <Column metaForDisplay={DataClass.OrderSerachReport.TotalFactor} />
                    <Column metaForDisplay={DataClass.OrderSerachReport.TotalDiscount} />
                    <Column metaForDisplay={DataClass.OrderSerachReport.PayAmount} />
                    <Column metaForDisplay={DataClass.OrderSerachReport.RefId} />
                    <Column metaForDisplay={DataClass.OrderSerachReport.UserNameDisplay} />
         

         




                </ProTable>
            </FromBasic>
        }
    }



}

class CityMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { isLoaded: false, Record: [] };
        this.submit = this.submit.bind(this);
    }
    componentDidMount() {
        let cmd = this;
        let hlp = new Helper();
        hlp.Ajax("City", "List", {}, function (datas) {
            cmd.setState({ isLoaded: true, Records: datas });

        }, function () { });

    }
    submit() {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let data = h.GetDataGrouped(window.Citys);
        h.Ajax('City', 'SaveBatch', { Inserted: data[RowState.Inserted], Updated: data[RowState.Changed], deleted: data[RowState.Deleted] }
            , function (data) {
                h.MessageBox(FixedMessage.NoProblem, FixedMessage.Result);
                h.GoBack();
            },
        )
    }
    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();
        }
        else {
            return <FromSubmit SubmitButtonOnTop={true} submitBev={this.submit} >
                <ProTable datasourcename='Citys' Records={this.state.Records} Insertable={true} Deleteable={true}>
                    <Column metaForDisplay={DataClass.City.id} />
                    <Column metaForInput={DataClass.City.title} />
                    <Column metaForInput={DataClass.City.stateName} />

                </ProTable>

            </FromSubmit>

        }

    }


}

export class DevMethodMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });
        this.Delete = this.Delete.bind(this);
        this.Refersh = this.Refersh.bind(this);

    }

    Delete(record) {
        let hlp = new Helper();
        let cmd = this;
        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('DevMethod', 'Delete', { Model: record }, function (data) {
                cmd.componentDidMount();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }

    Refersh() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('DevMethod', 'List', {}, function (data) {
            cmd.setState({ isLoaded: true, Records: data });
        });
    }

    componentDidMount() {
        this.Refersh();
    }

    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle=''>
                <AddButton title='' entity='DevMethod' /> <ProTable Records={this.state.Records} datasourcename='DevMethods'>
                    <Column metaForDisplay={DataClass.DevMethod.Id} />
                    <Column metaForDisplay={DataClass.DevMethod.Name} />
                    <Column metaForDisplay={DataClass.DevMethod.Description} />
              
                    <Column metaForDisplay={DataClass.DevMethod.Cost} />

                    <Action caption="ویرایش" type="Link" pageName="/DevMethod/Edit" />


                    <Action caption="حذف" type="function" targetFun={this.Delete} />




                </ProTable>
            </FromBasic>
        }
    }



}



/* درج و و یرایش رکورد */


export class AddDevMethod extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.submit = this.submit.bind(this);
    }
    submit() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let id = (cmd.id == undefined ? -1 : cmd.id);
        let o = h.GetPostData();
        h.Ajax('DevMethod', (cmd.id == '-1' ? 'Insert' : 'Update'), { Model: o, id: id }, function (data) {
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                h.GoBack();
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
    }
    componentDidMount() {
        let h = new Helper();
        if (this.id != -1) {
            h.Ajax('DevMethod', 'Get', { id: this.id }, function (data) {
                h.SetDataBack(data);
            });


        }
    }
    render() {
        return <FromSubmit submitBev={this.submit}>
        
            <InputBox meta={DataClass.DevMethod.Name} size='33%' />

            <InputBox meta={DataClass.DevMethod.ProductId} size='33%' />
          
            <InputBox meta={DataClass.DevMethod.Cost} size='33%' />
            <InputBox meta={DataClass.DevMethod.Description} size='100%' />

        </FromSubmit>

    }

}

function EditDevMethod() {
    const queryS = useParams();
    return <AddDevMethod id={queryS.id} />
}

function LoanOrder(props) {
    const [pageState, setState] = useState({ data: null, isLoaded: false });
    const id = useParams().id;

    const loadData = () => {
        let h = new Helper();
        h.Ajax('Order', 'GetPayInfo', { id: id },
            (data) => {
                setState({ data: data, isLoaded: true });
                setTimeout(() => { h.SetDataBack(data); }, 500);
            }


        );

    };


  




    const submit = () => {
        let h = new Helper();
        h.Validate();
        if (h.isValidate()) {
            let data = h.GetPostData();
            data.OrderId = id;
            h.Ajax('Loan', 'Insert', data, (result) => {
                h.Alert(result.message);
                if (result.status == 200) {
                    h.GoBack();
                }

            });
        }
     

    };

    if (pageState.isLoaded == false) {
        loadData();
        return <LoadingBar />;
    }

    let h = new Helper();
    return <FromSubmit submitBev={submit}>
        <FormDiv size='100%'>
            نام مشتری: {pageState.data.customerName} تاریخ سفارش : {pageState.data.orderDate} مبلغ کل فاکتور :{h.addCommas(pageState.data.totalFactor)}
        </FormDiv>
        <InputBox meta={DataClass.Loan.FristTime} size="100%" ></InputBox>
        <InputBox meta={DataClass.Loan.FristPayAmount} size="100%" ></InputBox>
        <InputBox meta={DataClass.Loan.TotalPart} size="100%" ></InputBox>
        <InputBox meta={DataClass.Loan.DayBetween} size="100%" ></InputBox>
    </FromSubmit>
}

function LoanDetail(props) {
    const [pageState, setState] = useState({ data: null, isLoaded: false });
    const id = useParams().id;

    const loadData = () => {
        let h = new Helper();
        h.Ajax('Loan', 'LoanDetail', { orderId: id },
            (data) => {
                setState({ data: data, isLoaded: true });
                setTimeout(() => { h.SetDataBack(data); }, 500);
            }


        );

    };


    const SendSms = (r) => {
        let h = new Helper();
        h.Ajax('Loan', 'SendSms', { id: r.id },
            (data) => {
                h.Alert(data.message);
            }


        );

    };
    const UpdateLoan=()=>
    {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == true) {
            data = h.GetDataGrouped(window.LoanDetails)[RowState.Changed];
            for (var l = 0; l < data.length; l++) {
                data[l].inComingDate = h.perToMil(data[l].inComingDate);
                
            }


            h.Ajax('Loan', 'UpdateItems', { orderId: id, updated :data}, (result) => {
                h.Alert(result.message);
                if (result.status == 200) {
                    h.GoBack();
                }

            });
        }
    }




    

    if (pageState.isLoaded == false) {
        loadData();
        return <LoadingBar />;
    }
    return <FromBasic>
        <center>
            <SimpleButton onClick={UpdateLoan} title="اصلاح اقساط"></SimpleButton>
        </center>
        <ProTable Records={pageState.data.details} datasourcename='LoanDetails'>
            <Column metaForDisplay={DataClass.LoanDetail.id} />
            <Column metaForDisplay={DataClass.LoanDetail.LoanId} />
     
            <Column metaForInput={DataClass.LoanDetail.InComingDate} />
            <Column metaForInput={DataClass.LoanDetail.Price} />
            <Column metaForDisplay={DataClass.LoanDetail.PayStatus} />
            <Column metaForDisplay={DataClass.LoanDetail.PayAmount} />
            <Column metaForDisplay={DataClass.LoanDetail.PayDate} />
            <Column metaForDisplay={DataClass.LoanDetail.PayDescr} />
            <Column metaForDisplay={DataClass.LoanDetail.RefId} />
            <Action caption="تعیین تکلیف مالی" Icon="Wallet" type="Link" pageName="/Loan/SetPayInfo" columnName="id" />
            <Action caption="ارسال پیامک" type="function" targetFun={SendSms} />
            </ProTable>
    </FromBasic>

}


function LoanSetPayStatus() {
    const [pageState, setState] = useState({ data: null, isLoaded: false });
    let id = useParams().id;

    const loadData = () => {
        let h = new Helper();
        h.Ajax('Loan', 'GetPayInfo', { id: id },
            (data) => {
                setState({ data: data, isLoaded: true });
                setTimeout(() => { h.SetDataBack(data); }, 500);
            }


        );

    };
    const submit = () => {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == true) {
            let o = { model: h.GetPostData(), id: id };
            h.Ajax('Loan', 'SetPayInfo', o, (data) => {
                h.MessageBox(data.message, 'نتیجه');
                if (data.status == 200) {
                    h.GoBack();
                }


            });

        }

    };


    if (pageState.isLoaded == false) {
        loadData();
        return LoadingBar();

    }




    let h = new Helper();
    return <FromSubmit submitBev={submit}>
        <FormDiv size='100%'>
         
        </FormDiv>

        <SelectBasic caption="وضعیت پرداخت" columnName="payStatus" mustFill={true}
            source={enums.PayStatus} size='33%' onChange={() => {
                let v = $('#txtpayStatus').val();
                switch (v) {
                    case '0':
                        $('#txtPayAmount').val(0);
                        break;
                    case '1':
                        $('#txtPayAmount').val(h.addCommas(pageState.data.price));
                        break;
                    case '2':
                        $('#txtPayAmount').val(h.addCommas(pageState.data.price));
                        break;
                    case '3':
                        $('#txtPayAmount').val(h.addCommas(pageState.data.price));
                        break;
                    default:
                        $('#txtPayAmount').val('');
                        break;
                }


            }}

        ></SelectBasic>
        <InputBox meta={DataClass.Order.PayDate} size='33%' />
        <InputBox meta={DataClass.Order.PayAmount} size='33%' />
        <InputBox meta={DataClass.Order.RefId} size='100%' />
        <InputBox meta={DataClass.Order.PayDescr} size='100%' />
        <br />
        چنانچه فعلا شماره پیگیری ندارید به جای کد پیگیری - درج نمائید
        <br />

    </FromSubmit>
}

export class LoanInComingDateResultMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });
       
        this.Refersh = this.Refersh.bind(this);

    }

   

    Refersh() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('Loan', 'MustPayed', {}, function (data) {
            cmd.setState({ isLoaded: true, Records: data });
        });
    }

    componentDidMount() {
        this.Refersh();
    }
     SendSms  (r) {
        let h = new Helper();
        h.Ajax('Loan', 'SendSms', { id: r.id },
            (data) => {
                h.Alert(data.message);
            }


        );

    }
    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle=''>
                <AddButton title='' entity='LoanInComingDateResult' /> <ProTable Records={this.state.Records} datasourcename='LoanInComingDateResults'>
                    <Column metaForDisplay={DataClass.LoanInComingDateResult.id} />
                    <Column metaForDisplay={DataClass.LoanInComingDateResult.LoadId} />
                    <Column metaForDisplay={DataClass.LoanInComingDateResult.OrderId} />
                    <Column metaForDisplay={DataClass.LoanInComingDateResult.CustomerName} />
                    <Column metaForDisplay={DataClass.LoanInComingDateResult.InComingDate} />
                    <Column metaForDisplay={DataClass.LoanInComingDateResult.PayStatus} />
                    <Column metaForDisplay={DataClass.LoanInComingDateResult.Price} />
                    <Action caption="تعیین تکلیف مالی" Icon="Wallet" type="Link" pageName="/Loan/SetPayInfo" columnName="id" />
                    <Action caption="ارسال پیامک" type="function" targetFun={this.SendSms} />
                    <Action caption="نمایش فاکتور" type="function" targetFun={(r) => {
                        window.open("/sf/" + r.orderId);
                    }} />




                </ProTable>
            </FromBasic>
        }
    }



}
class ProductSubSet extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = this.props.id;
        this.state = { Records: [], isLoaded: false };
        this.Submit = this.Submit.bind(this);
    }
    componentDidMount() {
        let helpCls = new Helper();
        let cmd = this;
        helpCls.Ajax('Product', 'GetSubProducts', { id: this.id },
            function (e) {
                console.log('Data Loaded!');
                cmd.setState({ isLoaded: true, Records: e });
            }, function (f) {
                console.log('Error');
            }
        );

    }
    Submit() {
        let hel = new Helper();
        let d = {
            id: this.id,
            selected: hel.GetRecordWithCircita(window.products, 'selected', true)
        };
        let cmd = this;
        hel.Ajax('Product', 'SetSubProducts', d,
            function (data) {
                hel.Alert(data.message, FixedMessage.Result);
                if (data.status == '200') {
                    hel.GoBack();
                }
                else {

                }
                   
            }
            , function (err) {
                hel.Error(FixedMessage.ErrorRaise, FixedMessage.Result);
            }

        )


    }
    render() {
        if (this.state.isLoaded == false) {
            return <LoadingBar />;
        }
        else {
            return <FromSubmit SubmitButtonOnTop={true} staticTitle='تعیین مجوز ها' SubmitButtonOnTop={true} submitBev={this.Submit} >



                <ProTable Records={this.state.Records} datasourcename='products'>
                    <Column type={ColumnType.DisplayValue} columnName='productName' caption='محصولات' />

                    <Column type={ColumnType.InputCheck} columnName='selected' />
                </ProTable>
            </FromSubmit>

        }

    }

}
class ProductSubQuickPriceEdit extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = this.props.id;
        this.state = { Records: [], isLoaded: false };
        this.Submit = this.Submit.bind(this);
    }
    componentDidMount() {
        let helpCls = new Helper();
        let cmd = this;
        helpCls.Ajax('Product', 'GetSubProductListForQuickEdit', { id: this.id },
            function (e) {
            
                console.log('Data Loaded!');
                cmd.setState({ isLoaded: true, Records: e });
            }, function (f) {
                console.log('Error');
            }
        );

    }
    Submit() {
        let hel = new Helper();
        let d = {
            id: this.id,
            products: window.products
        };
        let cmd = this;
        hel.Ajax('Product', 'SetSubProductForPriceEdit', d,
            function (data) {
                hel.Alert(data.message, FixedMessage.Result);
                if (data.status == '200') {
                    hel.GoBack();
                }
                else {

                }

            }
            , function (err) {
                hel.Error(FixedMessage.ErrorRaise, FixedMessage.Result);
            }

        )


    }
    render() {
        if (this.state.isLoaded == false) {
            return <LoadingBar />;
        }
        else {
            return <FromSubmit SubmitButtonOnTop={true} staticTitle='تعیین مجوز ها' SubmitButtonOnTop={true} submitBev={this.Submit} >



                <ProTable Records={this.state.Records} datasourcename='products'>
                    <Column type={ColumnType.DisplayValue} columnName='productName' caption='عنوان' />
                    <Column type={ColumnType.InputNumberDigited} columnName='price' caption='نرخ ریالی' />
                    <Column type={ColumnType.InputSelect2Static} source={enums.ViewStatus} columnName='viewStatus' caption='وضعیت در ویترین' />
                    <Column type={ColumnType.InputCheck} caption="غیرفعازی بروزرسانی خودکار" columnName='disableUpdate' />

                </ProTable>
            </FromSubmit>

        }

    }

}







function ProductSubList(prop) {
    const id = useParams().id;
    return <ProductSubSet id={id } />;

}
function SubProductPriceEditor(prop) {
    const id = useParams().id;
    return <ProductSubQuickPriceEdit id={id} />;

}


export class ProductCulsterMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });
        this.Delete = this.Delete.bind(this);
        this.Refersh = this.Refersh.bind(this);

    }

    Delete(record) {
        let hlp = new Helper();
        let cmd = this;
        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('ProductCulster', 'Delete', { Model: record }, function (data) {
                cmd.componentDidMount();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }

    Refersh() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('ProductCulster', 'List', {}, function (data) {
            cmd.setState({ isLoaded: true, Records: data });
        });
    }

    componentDidMount() {
        this.Refersh();
    }

    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle=''>
                <AddButton title='' entity='ProductCulster' /> <ProTable Records={this.state.Records} datasourcename='ProductCulsters'>
                    <Column metaForDisplay={DataClass.ProductCulster.Id} />
                    <Column metaForDisplay={DataClass.ProductCulster.Name} />

                    <Action caption="ویرایش" type="Link" pageName="/ProductCulster/Edit" columnName="id" />


                    <Action caption="حذف" type="function" targetFun={this.Delete} />




                </ProTable>
            </FromBasic>
        }
    }



}


/* دریافت تمامی رکورد ها */
  

 
/* ویرایش */
 
/* درج و و یرایش رکورد */


export class AddProductCulster extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.submit = this.submit.bind(this);
        
            this.state = { isLoaded: false, Records: [] };
        this.load = this.load.bind(this);
    }
    submit() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let id = (cmd.id == undefined ? -1 : cmd.id);
        let o = h.GetPostData();
        let d = {
            id: this.id,
            selected: h.GetRecordWithCircita(window.products, 'selected', true)
        };
      
       
        

        h.Ajax('ProductCulster', (cmd.id == '-1' ? 'Insert' : 'Update'), { Model: o, id: id, items: d.selected }, function (data) {
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                h.GoBack();
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
    }
    componentDidMount() {
        let h = new Helper();
        if (this.id != -1) {
            h.Ajax('ProductCulster', 'Get', { id: this.id }, function (data) {
                h.SetDataBack(data);
                window.products = data;
            });


        }
       
    }
     

    load() {
        let h = new Helper();
        let cmd = this;
        h.Ajax('ProductCulster', 'GetProducts', { id: this.id }
            , (data) => {
                cmd.setState({ Records: data, isLoaded: true });
                window.products = data;
            });
          
        
    }
    render() {
        if (this.state.isLoaded == false) {
            this.load();
           
        }

        return <FromSubmit submitBev={this.submit}>
            
            <InputBox meta={DataClass.ProductCulster.Name} size='50%' />
            <ProTable Records={this.state.Records} datasourcename='products'>
                <Column type={ColumnType.DisplayValue} columnName='productName' caption='محصولات' />

                <Column type={ColumnType.InputCheck} columnName='selected' />
            </ProTable>

        </FromSubmit>

    }

}

function EditProductCulster() {
    const queryS = useParams();
    return <AddProductCulster id={queryS.id} />
}

function ProductImagesMgtStarter() {
    const queryS = useParams();
    return <ProductImagesMgt id={queryS.id} />
}



export function ProductServiceApp(props) {

    let routes = [
        <Route path="Products" element={<ProductMgt />} />,
        <Route path="Citys" element={<CityMgt />} />,
        <Route path="DevMethods" element={<DevMethodMgt />} />,
        <Route path="DevMethod/Add" element={<AddDevMethod id="-1" />} />,
                                           <Route path="DevMethod/Edit/:id" element={<EditDevMethod />} />,
        <Route path="CheckForPay" element={<CheckForPay />} />,
        <Route path="Product/Add" element={<AddProduct id="-1" />} />,
        <Route path="ProductsCat" element={<ProdcutCategoryMgt />} />,
        <Route path="Product/Edit/:id" element={<EditProduct />} />,
        <Route path="Product/Sub/:id" element={<ProductSubList />} />,
        <Route path="Product/SubPrice/:id" element={<SubProductPriceEditor />} />,
        <Route path="Product/Images/:id" element={<ProductImagesMgtStarter />} />,

        <Route path="Sell" element={<OrderMamanget />} />,
        <Route path="Sell/:status" element={<OrderMamanget />} />,
        <Route path="Sell/Add" element={<AddOrder id={-1} />} />,
        <Route path="Sell/StartDel/:id" element={<SetDelverSingle />} />,
        <Route path="DirectPay/Add" element={<AddDirectPay id={-1} />} />,
        <Route path="DirectPays" element={<DirectPayMgt />} />,
        <Route path="DirectPays/SetDel/:id" element={<SetDirectPayOrderDel />} />,
        <Route path="DirectPays/0" element={<DirectPayMgt mode={0} key={ 0} />} />,
        <Route path="DirectPays/2" element={<DirectPayMgt mode={2} key={2} />} />,
        <Route path="DirectPays/3" element={<DirectPayMgt mode={3} key={3} />} />,
        <Route path="Sell/Edit/:id" element={<EditOrder />} />,
        <Route path="CreateLoan/:id" element={<LoanOrder />} />,
        <Route path="LoanDetail/:id" element={<LoanDetail />} />,
        <Route path="Sell/SerachBySerail" element={<SerailBySerail />} />,
        <Route path="Sell/InputSerail/:id" element={<InputSerail />} />,
        ,
        <Route path="FactorTemplates" element={<FactorTemplateMgt />} />,
<Route path="FactorTemplate/Add" element={<AddFactorTemplate id="-1" />} />
                                           ,<Route path="FactorTemplate/Edit/:id" element={<EditFactorTemplate />} />

        ,
        <Route path="DeleryMgt" element={<DeleryManagement />} />,

        , <Route path="DetailReport" element={<DetailSerach />} />,
        <Route path="Customers" element={<CustomerMgt />} />,
        <Route path="Customer/Add" element={<AddCustomer id="-1" />} />,
        <Route path="Customer/Edit/:id" element={<EditCustomer />} />
        , <Route path="Report/RemainCustomer" element={<CustomeRemainFactorDtoMgt />} />
        , <Route path="Report/ProductSell" element={<ProductSellReport />} />
        , <Route path="Report/SellReportGrouped" element={<GroupedSellReport />} />
        , <Route path="Report/UnitPriceCheck" element={<UnitPriceCheck />} />
        , <Route path="Report/LoanMustPayed" element={<LoanInComingDateResultMgt />} />

        

        
        ,

        <Route path="Sell/SetPayInfo/:id" element={<SetPayStatus />} />,
        <Route path="Loan/SetPayInfo/:id" element={<LoanSetPayStatus />} />
        ,

        <Route path="StroageTransactions" element={<StroageTransactionMgt />} />,
<Route path="StroageTransaction/Add" element={<AddStroageTransaction id="-1" />} />,
                                           <Route path="StroageTransaction/Edit/:id" element={<EditStroageTransaction />} />,

        <Route path="StroageReport" element={<StorageReport />} />,
        <Route path="CustomeGroups" element={<CustomeGroupMgt />} />,
        
<Route path="ProductCulsters" element={<ProductCulsterMgt />} />,
<Route path="ProductCulster/Add" element={<AddProductCulster id="-1" />} />,
                                           <Route path="ProductCulster/Edit/:id" element={<EditProductCulster />} />



    ];
    return routes;
}
